window.KEY = {
    UP: 38,
    DOWN: 40,
    DEL: 46,
    TAB: 9,
    RETURN: 13,
    ESC: 27,
    PAGEUP: 33,
    PAGEDOWN: 34,
    BACKSPACE: 8,
    SPACE: 32,
    HOME: 36,
    END: 35,
    F2: 113,

    COMMA: 188,
    "," : 188,
    "." : 190,
    "!" : 49,
    "?" : 191,
    ":" : 186,
    ";" : 186,
    "'" : 122
};

window.common = {};
// берет массив и записывает его в строку, удобную для отправки
// $array - указатель на массив.
// name - имя массива
common.get_array_inline = function($arr, name)
{

	var line=""; // сюда будет записывать эту самую строку.
	var i = 0; // счетчик цикла

	for (i in $arr)
	{

		if(i>0) line += "&";
		line += name+"["+i+"]="+$arr[i];
		i++;


	};

	return line;

} // end of msgbox.get_Ids$array_inline


// проверяет, есть ли у массива элемент value
common.getElementKey = function(value, $arr)
{

  //  alert("%%");
    var keys = [];
    for(var i in $arr)
	{

        //alert($arr[i]+" <> " + value);
        if($arr[i] == value) keys[keys.length] = i;

	}

    if (keys.length == 0) return false;
    else if (keys.length == 1) return keys[0];
    else return keys;

} // end of common.getElementKey()


common.deleteElementByValue = function(value, $arr)
{

	var key;
	if((key=common.getElementKey(value, $arr))!==false)
    {
        common.deleteElementByKey(key, $arr);
        return true;
    }
    else return false;

} // end of common.deleteElementByValue()


common.deleteElementByKey = function(key, $arr)
{

    if(Number(key) == NaN)
    {

        var i;
        for(i in key) this.deleteElementByKey[key[i]];

    }
    else
    {
    	var n = key;
    	for (n++; n<$arr.length; n++)
    	{
    		$arr[n-1] = $arr[n];

    	}

    	delete $arr[$arr.length];
    	$arr.length--;
    }

} // end of common.deleteElementByKey


common.str_replace = function(search, replace, subject) {
	return subject.split(search).join(replace);
} // end of common.str_replace


common.nl2br = function (str, is_xhtml) {
    // http://kevin.vanzonneveld.net
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   improved by: Philip Peterson
    // +   improved by: Onno Marsman
    // +   improved by: Atli ?or
    // +   bugfixed by: Onno Marsman
    // +      input by: Brett Zamir (http://brettz9.blogspot.com)
    // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // *     example 1: nl2br('Kevin\nvan\nZonneveld');
    // *     returns 1: 'Kevin<br />\nvan<br />\nZonneveld'
    // *     example 2: nl2br("\nOne\nTwo\n\nThree\n", false);
    // *     returns 2: '<br>\nOne<br>\nTwo<br>\n<br>\nThree<br>\n'
    // *     example 3: nl2br("\nOne\nTwo\n\nThree\n", true);
    // *     returns 3: '<br />\nOne<br />\nTwo<br />\n<br />\nThree<br />\n'

    var breakTag = '';

    breakTag = '<br />';
    if (typeof is_xhtml != 'undefined' && !is_xhtml) {
        breakTag = '<br>';
    }

    return (str + '').replace(/([^>]?)\n/g, '$1'+ breakTag);
}


// Рисует полоску с цифрами для выбора страницы.
$.fn.pagerator = function(options)
{

   //	alert("start");
    var defaults =
    {
        maxpage         : 10, // последняя страница
        page            : 1,
        show_arrows     : true, // показывать ли ссылки «предыдущая страница»/«следущая страница»
        arrow_bkw_txt   : "←",
        arrow_fwd_txt   : "→",
		title_txt		: "Страницы: ",
		show_borders    : true, // показывать ли границы интервала — первую и последнюю страницу.
        interval_radius : 4, // сколько еще будет показано страниц до и столько же после цифры, указывающей на текующую страницу
        onclick         : function(num){}//, // функция, которая будет вызываться при клике на цифру. num — нажатая цифра. $lnk — jQuery-указатель на объект — ссылку на страницу
		/////ondraw          : function(num, $lnk){} // вызывается после отрисовки каждой цифры. // пока не работает!!!
    };

    options = jQuery.extend(defaults, options);

    var jq = this;

    function get_pagelink_html(num)
    {
        var is_selected;
        num = Number(num);
        if(num > 0)
        {
            //if((is_selected == undefined) || !is_selected) is_selected = 0;
            if(num == options.page) is_selected = 1;
            else is_selected = 0;
            return '<span class="pgr'+(is_selected?' pgr_selected':'')+'"><a>'+num+'</a></span>';
        }
        else return false;
    }

    function init_pagerator()
    {

        var html = ""; //= '<span class="pgr_title">'+options.title_txt+'</span>';

        var spage = Number(options.page) - Number(options.interval_radius);
        var fpage = Number(options.page) + Number(options.interval_radius);
        if(spage < 1) spage = 1;
        if(fpage > options.maxpage) fpage = options.maxpage;

        //alert("page = "+options.page+"\nspage = "+spage+"\nfpage = "+fpage);

        var i;
        var h;
        for(i = spage; i <= fpage; i++)
        {
            h = get_pagelink_html(i);
            if(h !== false) html += h;
        };

        if(options.show_borders)
        {

            if(spage - 1 > 1) html = '<span class="pgr_more">…</span>'+html;
            if(fpage + 1 < options.maxpage) html += '<span class="pgr_more">…</span>';

            if(spage - 1 >= 1) html = '<span class="pgr"><a>1</a></span>'+html;
            if(fpage + 1 <= options.maxpage) html += '<span class="pgr"><a>'+options.maxpage+'</a></span>';

        }

        if(options.show_arrows)
        {
            if(options.page > 1) html = '<span class="pgr_arrow pgr_bkw"><a>'+options.arrow_bkw_txt+'</a></span>'+html;
            if(options.page < options.maxpage) html += '<span class="pgr_arrow pgr_fwd"><a>'+options.arrow_fwd_txt+'</a></span>';
        };

	   //	alert(html);
        $(jq).html('<span class="pgr_title">'+options.title_txt+'</span>'+html);
        /**/
        $(jq).find('.pgr a').click(function()
        {
            var num = $(this).text();
			open_page(num);
        });
        if(options.show_arrows)
        {
            $(jq).find(".pgr_bkw").click(function()
			{
				open_page(Number(options.page)-1);
			});
            $(jq).find(".pgr_fwd").click(function()
			{
				open_page(Number(options.page)+1);
			});
        };


        /***/

    };

	function open_page(num)
	{

    	options.page = num;
		options.onclick(num);
		init_pagerator();

	};


    init_pagerator();

    return this;

}

// JavaScript Document
/*
// ///////////////////////////
// isdefined v1.0
//
// Check if a javascript variable has been defined.
//
// Author : Jehiah Czebotar
// Website: http://www.jehiah.com
// Usage  : alert(isdefined('myvar'));
// ///////////////////////////
*/
function isDefined( variable)
{
    return (typeof(window[variable]) == "undefined")?  false: true;
}


function loadjscssfile(filename, filetype)
{
	if (filetype=="js")
	{ //if filename is a external JavaScript file
		var fileref=document.createElement('script');
		fileref.setAttribute("type","text/javascript");
		fileref.setAttribute("src", filename);
	}
	else if (filetype=="css")
	{ //if filename is an external CSS file
		var fileref=document.createElement("link");
		fileref.setAttribute("rel", "stylesheet");
		fileref.setAttribute("type", "text/css");
		fileref.setAttribute("href", filename);
	}
	if (typeof fileref!="undefined")
		document.getElementsByTagName("head")[0].appendChild(fileref);
}


window.checkloadjscssfile = function()
{
	var filesadded=""; //list of files already added

	return function(filename, filetype)
	{
		if (filesadded.indexOf("["+filename+"]")==-1)
		{
			loadjscssfile(filename, filetype);
			filesadded+="["+filename+"]"; //List of files added in the form "[filename1],[filename2],etc"
		}
	};
}();


$.getDocHeight = function(){
     var D = document;
     return Math.max(Math.max(D.body.scrollHeight,    D.documentElement.scrollHeight), Math.max(D.body.offsetHeight, D.documentElement.offsetHeight), Math.max(D.body.clientHeight, D.documentElement.clientHeight));
};

/**
 * @use var obj2 = new cloneObject(obj1);
 */
window.cloneObject = function(source)
{
    for (var i in source) {
        if (typeof source[i] == 'source') {
            this[i] = new cloneObject(source[i]);
        }
        else{
            this[i] = source[i];
        }
    }
}


String.prototype.startsWith = function(str) {
    return (this.length >= str.length)
        && (this.substr(0, str.length) == str);
};

String.prototype.startsWith_ci = function(str) {
    return this.toLowerCase().startsWith(str.toLowerCase());
};

window.selectText = function(element) {
    var doc = document
        , text = doc.getElementById(element)
        , range, selection
    ;
    if (doc.body.createTextRange) { //ms
        range = doc.body.createTextRange();
        range.moveToElementText(text);
        range.select();
    } else if (window.getSelection) { //all others
        selection = window.getSelection();
        range = doc.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
    }
}

/**
* Возвращает число вместе со строчкой с правильным окончанием в зависимости от числа num+
* @param integer num число
* @param string str1 текст для варианта «один» (1, 21, 31, …)
* @param string str2 текст для варианта «несколько» (2–4, 22-24, 32-34, …)
* @param string str3 текст для варианта «много» (всё остальное)
* @param string var_name (по умолчанию: "%d" без кавычек) — если данная строка будет встречена в тексте, именно она будет заменена на число. В противном случае, число будет добавлено в начало.
*/
window.get_correct_str = function(num, str1, str2, str3, var_name)
{
    if(empty(var_name)) var_name = "%d";

    var val = num % 100;
    var txt;

    if (val > 10 && val < 20) txt = str3;
    else
    {
        val = num % 10;
        if (val == 1) txt = str1;
        else if (val > 1 && val < 5) txt = str2;
        else txt = str3;
    }

    var a = txt.split(var_name);
    if(a.length > 1) return a.join(num);
    else return num + ' ' + txt;
}

//конвертирует байты в соответствующую величину
window.conv_size = function(b)
{
    var fsizekb = b / 1024;
    var fsizemb = fsizekb / 1024;
    var fsizegb = fsizemb / 1024;
    var fsizetb = fsizegb / 1024;

    var fsize;

    if (b < 1024)
    {
        fsize = b + ' байт';
    }
    else if (fsizekb < 1024)
    {
        fsize = fsizekb.toFixed(2) + ' кб';
    }
    else if (fsizekb >= 1024 && fsizemb < 1024)
    {
        fsize = fsizemb.toFixed(2) + ' мб';
    }
    else if (fsizemb >= 1024 && fsizegb < 1024)
    {
        fsize = fsizegb.toFixed(2) + ' гб';
    }
    else
    {
        fsize = fsizetb.toFixed(2) + ' тб';
    }
    return fsize;
};

 (function($, global, undefiend)
 {
        $.removeArrayElement = function(collection,key){
            // if the collections is an array
            if(collection instanceof Array)
                {
                    // use jquery's `inArray` method because ie8
                    // doesn't support the `indexOf` method
                    if($.inArray(key, collection) != -1)
                        collection.splice($.inArray(key, collection), 1);
                }
            // it's an object
            else if(collection.hasOwnProperty(key))
                delete collection.key;
            return collection;
        };


        $.cloneArr = function(source)
        {
            var arr = source.slice(0);
            for( var i = 0; i < this.length; i++ ) {
                if( source[i] instanceof Array) {
                    //recursion
                    source[i] = $.cloneArr(source[i]);
                }
            }
            return arr;
        };

})(jQuery, window);

window.isNumber = function (n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
window.isInt = function (n)
{
    return n != "" && !isNaN(n) && Math.round(n) == n;
}
window.isFloat = function (n){
    return n != "" && !isNaN(n) && Math.round(n) != n;
}

if (!String.prototype.encodeHTML) {
  String.prototype.encodeHTML = function () {
    return this.replace(/&/g, '&amp;')
               .replace(/</g, '&lt;')
               .replace(/>/g, '&gt;')
               .replace(/"/g, '&quot;')
               .replace(/'/g, '&apos;');
  };
}

if (!String.prototype.decodeHTML) {
  String.prototype.decodeHTML = function () {
    return this.replace(/&apos;/g, "'")
               .replace(/&quot;/g, '"')
               .replace(/&gt;/g, '>')
               .replace(/&lt;/g, '<')
               .replace(/&amp;/g, '&');
  };
}

window.escapeXml = function (unsafe) {
    return unsafe.replace(/[<>&'"]/g, function (c) {
        switch (c) {
            case '<': return '&lt;';
            case '>': return '&gt;';
            case '&': return '&amp;';
            case '\'': return '&apos;';
            case '"': return '&quot;';
        }
    });
}

window.createXmlField = function (sName, sValue)
{

    return '\t<field name="'+escapeXml(sName)+'">'+escapeXml(sValue)+'</field>\n';
}

window.createSerializedXmlObject = function (oForm, bShort)
{
    var docXml = '<?xml version="1.0" encoding="UTF-8"?>\n<form >\n';
    for (key in oForm)
    {
        docXml += createXmlField(key, oForm[key]);
    }
    if(bShort === undefined )
        docXml += '</form>\n';

    return docXml;
}
window.postToIframe = function (data,url,target)
{
    $('body').append('<form action="'+url+'" method="post" target="'+target+'" id="postToIframe"></form>');

    _serializeArrayToInputs(data, $('#postToIframe'));

    $('#postToIframe').submit().remove();
}

// Функция нужна для postToIframe
window._serializeArrayToInputs = function (data, $to, sNameSpace)
{
    $.each(data,function(n,v)
    {
        var sNameSpace, sInputName;
        if(sNameSpace === undefined) sInputName = n;
        else sInputName = sNameSpace+'['+n+']';

        if(typeof(v) == "object")
        {
            _serializeArrayToInputs(v, $to, sInputName);
        }
        else
        {
            $to.append('<input type="hidden" name="'+sInputName.encodeHTML()+'" value="'+v.encodeHTML()+'" />');
        }
    });
}


// Создаёт событие на завершение скролла (срабатывает через timeout милисекунд после того, как пользователь в последний рах использовал скролла)
$.fn.scrollEnd = function(callback, namespace, timeout)
{
  $(this).bind('scroll'+(namespace?('.'+namespace):''), (function()
  {
    var rScrollTimeout = null;
    return function()
    {
        if (rScrollTimeout) {
          clearTimeout(rScrollTimeout);
        }
        rScrollTimeout = setTimeout(callback,timeout);
    }
  })());
};

(function($) {
    $.fn.closest_descendent = function(filter) {
        var $found = $(),
            $currentSet = this; // Current place
        while ($currentSet.length) {
            $found = $currentSet.filter(filter);
            if ($found.length) break;  // At least one match: break loop
            // Get all children of the current set
            $currentSet = $currentSet.children();
        }
        return $found.first(); // Return first match of the collection
    }
})(jQuery);

(function($) {
    $.fn.replaceWithPush = function(a) {
        var $a = $(a);

        this.replaceWith($a);
        return $a;
    };
})(jQuery);
